import { Box, CircularProgress, Typography } from "@mui/material";
import React, { ReactElement } from "react";

interface PredictingOverlayProps {
  open: boolean;
}

const PredictingOverlay = (props: PredictingOverlayProps): ReactElement | null => {
  const { open } = props;

  if (!open) {
    return null;
  }

  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.78)",
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        justifyContent: "center",
        left: 0,
        position: "absolute",
        right: 0,
        top: 0,
        zIndex: 1,
      }}
    >
      <CircularProgress color="primary" />
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        Processing prediction...
      </Typography>
    </Box>
  );
};

export default PredictingOverlay;
